import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const cfg = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!cfg.apiKey) {
  // Create React App only loads .env.local / .env.production at dev-server
  // startup. If you just added .env.local, restart `npm start`.
  throw new Error(
    'Firebase config missing — REACT_APP_FIREBASE_API_KEY is undefined. '
    + 'If you just edited .env.local, stop and restart `npm start`.'
  );
}

export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
export const app  = initializeApp(cfg);
export const db   = getFirestore(app);
export const auth = getAuth(app);

let _messaging = null;
export async function getMessagingIfSupported() {
  if (_messaging !== null) return _messaging;
  try { _messaging = (await isSupported()) ? getMessaging(app) : false; }
  catch { _messaging = false; }
  return _messaging;
}

export { signInWithCustomToken, getToken, onMessage };
